<template>
    <div :class="show?'opacity-100':'opacity-0'" class="text-white flex-1 col-span-1 border-0 rounded-t-xl transition-opacity duration-1000 ease-in-out">
            <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl">
                <div class="bg-theme-green rounded-t-xl px-4 py-2 text-white">
                    <div class="flex justify-between items-center">
                        <div>
                            <h2 class="font-bold tracking-wider truncate text-single-line leading-tight text-2xl mt-0 mb-4">{{asn.name ? asn.name : (editItem.name ? editItem.name : 'N/A')}}</h2>
                            <h3 class="text-sm font-semibold truncate text-single-line leading-tight" v-if="editItem.brand">{{editItem.brand.name}}</h3>
                        </div>
                        <div class="flex flex-col">
                            <button @click="closeEdit" class="mb-3 flex justify-end">
                                CLOSE
                            </button>
                            <div class="mb-1 relative flex justify-end gap-[12px]" tabindex="1"  @focusout="focusOutDropDown">
                                <button @click="showMerge=true" class="uppercase hover:border-white/60 px-[14px] py-[10px] border border-white rounded text-sm tracking-widest text-white">
                                    merge
                                </button>
                                <button :disabled="disabledSave" v-if="editPage=='regular'" @click="save" name="save" class="uppercase hover:bg-slate-100 disabled:bg-gray-black px-[14px] py-[10px] bg-white rounded text-sm tracking-widest text-theme-green">
                                    save
                                </button>
                                <button @click="removeProduct" class="flex justify-center items-center hover:bg-slate-100 bg-white w-[40px] h-[40px] rounded">
                                    <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.6987 24C3.16536 24 2.6987 23.8 2.2987 23.4C1.8987 23 1.6987 22.5333 1.6987 22V3H0.332031V1H6.5987V0H15.3987V1H21.6654V3H20.2987V22C20.2987 22.5333 20.0987 23 19.6987 23.4C19.2987 23.8 18.832 24 18.2987 24H3.6987ZM18.2987 3H3.6987V22H18.2987V3ZM7.23203 19.1333H9.23203V5.83333H7.23203V19.1333ZM12.7654 19.1333H14.7654V5.83333H12.7654V19.1333ZM3.6987 3V22V3Z" fill="red"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div v-if="editPage!='adjust-inventory'">
                    <ul class="flex gap-[54px] bg-[#2B2C32] rounded-b-xl px-2 pt-3 pb-2">
                        <li @click="toggle('regular')" :class="editPage=='regular'?'active':''">
                            <a class="inline-block text-theme-white  tracking-widest text-sm font-semibold" href="#">GENERAL</a>
                        </li>
                        <li @click="toggle('media')" :class="editPage=='media'?'active':''">
                            <a class="text-theme-dimwhite tracking-widest text-sm font-semibold" href="#">MEDIA</a>
                        </li>
                        <li @click="toggle('terpene')" :class="editPage=='terpene'?'active':''">
                            <a class="text-theme-dimwhite tracking-widest text-sm font-semibold uppercase" href="#">Terpenes</a>
                        </li>
                    </ul>
                </div>
                
                <div v-if="showMerge" class="border border-theme-orange rounded-lg pt-4 pb-2 px-2 my-1">
                    <div>
                        <business-search-select placeholder="Search" :asn="asn" @select="selectForceProductItem" />
                    </div>
                    <div class="grid grid-cols-1 gap-1 mt-2 mb-1">
                        <button :disabled="!mergeProduct?.id" class="w-full border border-theme-green rounded uppercase py-2" :class="(mergeProduct?.id)?'bg-theme-green hover:bg-theme-green-300 border-theme-green':'border-transparent bg-field-black text-theme-modalbg'" @click="confirmForceMerge">Confirm</button>
                    </div>
                </div>
                <component :productLoading="productLoading" :is="editPage" :asn="asn" :mergeProduct="confirmedMergeVariant" :fulfillment="fulfillment" :categories="categories" :brands="brands" :taxes="taxes" :editItem="editItem" :media="media" :aromas="aromas" :terpenes="terpenes" :globalSetting="globalSetting" />
            </div> 
    </div>
</template>
<script>
import { ref, defineComponent } from 'vue'
import Helpers from '@/helpers'
import ProductHelper from '@/helpers/product'
import ObjectHelper from '@/helpers/object'
import Regular from './Regular.vue'
import Media from './Media.vue'
import Terpene from './terpene/Terpene.vue'
import ProductApi from '@/controllers/BusinessProductApis'
import PriceMarkupSettingApis from "@/controllers/LocationMarkupPrice";
import LocationCannabisSettingApi from '@/controllers/LocationCannabisSetting';
import {mapGetters, mapMutations} from 'vuex'
import { useSnackbar } from "vue3-snackbar"
import BusinessSearchSelect from './businessSearchSelect'


export default defineComponent({
    props: ['asn', 'fulfillment', 'editItem'],
    components: {
        Regular,
        Media,
        Terpene,
        BusinessSearchSelect
    },
    setup() {
        const productLoading = ref(false)
        const show = ref(true)
        const snackbar = useSnackbar();
        const globalSetting = ref({})
        const categories = ref([])
        const brands = ref([])
        const taxes = ref([])
        const editPage = ref('regular')
        const showMerge = ref(false)
        const mergeProduct = ref({})
        const confirmedMergeVariant = ref({})
        const subVariant = ref(false)
        const media = ref([])
        const aromas = ref([])
        const terpenes = ref([])
        const disabledSave = ref(false)
        const form = ref({
            name: '',
            brandId: '',
            categoryId: '',
            featuredCategoryIds: [],
            strain: '',
            tax: '',
            complianceType: '',
            stock: 0,
            stock_threshold: '',
            sku: '',
            concentration_unit: '',
            description: '',
            longDescription: '',
            thc: '',
            thc_min: '',
            thc_max: '',
            cbd: '',
            cbd_min: '',
            cbd_max: '',
            totalTerp: '',
            caseSize: '',
            licensedProducer: '',
            variantName: '',
            dryCannabisEquivalency: '',
            thc_cbd_value_type: 'single',
            cost: '',
            price: '',
            sale_price: '',
            barcode: '',
            reservedQty: 0,
            fulfillmentTime: '',
            activeStock: 0,
        })

        return {productLoading, show, snackbar, globalSetting, categories, brands, taxes, editPage, showMerge, mergeProduct, confirmedMergeVariant, subVariant, media, aromas, terpenes, disabledSave, form}
    },
    mounted(){
        let self = this
        this.vm_spinner(true)
        let promise0 = this.fetchLotSetting()
        let promise1 = this.getCategory()
        let promise2 = this.getBrand()
        let promise3 = this.getTaxes()
        Promise.all([promise0, promise1, promise2, promise3]).then(() => {
            self.vm_spinner(false)
        })
        this.getImageAndTerpenes()
        this.emitter.on("added", this.addedFromAsn);
        this.emitter.on("toggleSave", this.toggleSave);
        this.emitter.on("showDefaultVariant", this.showDefaultVariant)
        this.emitter.on("updateMediaTerpeneAroma", this.updateMediaTerpeneAroma)
    },
    beforeDestroy(){
        this.emitter.off("toggleSave", this.toggleSave);
        this.emitter.off("showDefaultVariant", this.showDefaultVariant)
        this.emitter.off("updateMediaTerpeneAroma", this.updateMediaTerpeneAroma)
    },
    unmounted(){
        this.emitter.off("toggleSave", this.toggleSave);
        this.emitter.off("showDefaultVariant", this.showDefaultVariant)
        this.emitter.off("updateMediaTerpeneAroma", this.updateMediaTerpeneAroma)
    },
    watch: {
        editItem(item){
            this.editPage = 'regular'
            let self = this
            this.show = false
            this.vm_spinner(true)
            let promise0 = this.fetchLotSetting()
            let promise1 = this.getCategory()
            let promise2 = this.getBrand()
            let promise3 = this.getTaxes()
            Promise.all([promise0, promise1, promise2, promise3]).then(() => {
                self.vm_spinner(false)
                self.show = true
            })
            this.getImageAndTerpenes()
        }
    },
    computed: {
        ...mapGetters({
            vg_selectedBusiness: 'auth/activeBusiness',
            vg_selectedLocation: 'location/selected',
            vg_modified: 'modifiedForm/status'
        })
    },
    methods: {
        getImageAndTerpenes(){
            if(this.editItem.image){
                this.media =[{id: this.editItem.image}]
            }else{
                this.media = []
            }
            if(this.editItem.terpene?.length>0){
                this.terpenes = [...this.editItem.terpene]
            }else{
                this.terpenes = []
            }
            if(this.editItem.aroma?.length>0){
                this.aromas = [...this.editItem.aroma]
            }else{
                this.aromas = []
            }
        },
        addedFromAsn(row){
            this.$emit('added', row)
        },
        closeEdit(){
            if(this.editPage=='adjust-inventory'){
                this.editPage = 'regular'
            }else{
                this.$emit('close')
            }
        },
        async toggle(name){
            this.editPage = name
        },
        save(){
            this.emitter.emit('saveEditProduct', true)
        },
        updateMediaTerpeneAroma({type, add, remove}){
            if(type==='media'){
                remove?this.remove('media', remove):this.add('media', add)
            }else if(type==='terpenes'){
                remove?this.remove('terpenes', remove):this.add('terpenes', add)
            }else if(type==='aromas'){
                remove?this.remove('aromas', remove):this.add('aromas', add)
            }
        },
        add(type, add){
            let findInd = this[type].findIndex(each => each.id===add.id)
            if(findInd==-1){
                this[type].push(add)
            }
        },
        remove(type, remove){
            let findInd = this[type].findIndex(each => each.id===remove.id)
            if(findInd>=0){
                this[type].splice(findInd, 1)
            }
        },
        async fetchLotSetting(){
            let res = await LocationCannabisSettingApi.fetchSetting();
            this.globalSetting =  res.status == 200 ? res.data.payload : {lotTracking: false};
        },
        async getCategory(){
            this.categories = []
            let res = await ProductApi.fetchAllCategory()
            if(res.data?.payload?.category){
                for(let i=0; i<res.data.payload.category.length; i++){
                    this.categories.push(res.data.payload.category[i])
                    if(res.data.payload.category[i].subCategories && res.data.payload.category[i].subCategories.length>0){
                        for(let j=0; j<res.data.payload.category[i].subCategories.length; j++){
                            this.categories.push(res.data.payload.category[i].subCategories[j])
                        }
                    }
                }
            }
        },
        async getBrand(){
            let res = await ProductApi.fetchAllBrands()
            if(res.data?.payload?.brands){
                this.brands = res.data.payload.brands
            }
        },
        async getTaxes(){
            if(this.vg_selectedBusiness.id){
                let res = await ProductApi.fetchAllTaxes(this.vg_selectedBusiness.id)
                if(res.data?.payload){
                    this.taxes = res.data.payload
                }
            }
        },
        toggleSave(value){
            this.disabledSave = value
        },
        showDefaultVariant(){
            this.editPage = 'regular'
        },
        /**
         * Close Qr Card Modal
         */
        closeCallBack() {
          this.productCard = {
            modal: false,
            product: {},
          };
        },

        selectForceProductItem({type, productObj}){
            this.subVariant = type
            this.mergeProduct = productObj
        },
        async confirmForceMerge(){
            if(this.subVariant){
                this.vm_spinner(true)
                if(this.mergeProduct?.id){
                    let res = await ProductApi.updateProductOrderItems({items: [{...this.asn, productId: this.mergeProduct.id}]})
                    this.snackbar.add({
                        type: 'info',
                        text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                        duration: 3000,
                    })
                    if(res.status==200){
                        this.emitter.emit("reloadAddAsnList")
                        this.emitter.emit('closeAddEditInPurchaseOrder')
                    }
                }
                this.vm_spinner(false)
            }else{
                this.vm_spinner(true)
                let res = await PriceMarkupSettingApis.fetchByLocationId(this.vg_selectedLocation.id)
                let markupPrices = ObjectHelper.getDefaultMarkup(res?.data?.payload)
                let data = ProductHelper.getDataFromMergeToPO(this.asn, this.mergeProduct, this.vg_selectedLocation.id, markupPrices, this.fulfillment)
                let result = await ProductApi.addOrUpdatePurchaseOrderItem(data)
                this.vm_spinner(false)
                this.snackbar.add({
                    type: 'info',
                    text: (result.status == 200 || result.status==201) ? "Product updated successfully." : Helpers.catchErrorMessage(result.response.data),
                    duration: 3000,
                })
                if(result.status==200 || result.status==201){
                    // save and reload
                    this.emitter.emit("reloadAddAsnList")
                    this.emitter.emit('closeAddEditInPurchaseOrder')
                }else{
                    // go through merge process
                    this.confirmedMergeVariant = {...this.mergeProduct}
                    this.showMerge = false
                    // this.snackbar.add({
                    //     type: 'info',
                    //     text: 'Merged to existing product.',
                    //     duration: 3000,
                    // })
                }
            }
        },
        removeProduct(){
            this.confirmNew('Remove Product', `Are you sure you want to remove <b>${this.editItem.name}</b> from the Purchase Order?`, 'Yes', 'bg-theme-red text-white').then(async () => { 
                this.vm_spinner(true)
                let res = await ProductApi.removePOV2(this.asn.purchaseOrderId, {itemId: this.asn.id})
                if(res.status===200){
                    this.emitter.emit("reloadAddAsnList")
                    this.emitter.emit('closeAddEditInPurchaseOrder')
                }
                this.snackbar.add({
                    type: 'info',
                    text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                    duration: 3000,
                })
                this.vm_spinner(false)
            }).catch(err => {
                console.log(err)
            })
        },
        ...mapMutations({
            vm_spinner: 'spinner/mutateSpinner',
            vm_modified: 'modifiedForm/mutateStatus'
        })
    }
})
</script>
<style scoped>
    .active{
        /* position:relative; */
        border-bottom: solid 4px #2BA66B;
    }
    /* .active:before {
    content: '';
    position: absolute;
    background: #2BA66B;
    width: 100%;
    height: 4px;
    bottom: -12px;
    } */
  </style>
